<div class="card-body">

  <form>

    <div class="row">

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Responsible Calibration Technician</label>
        <select class="custom-select" [(ngModel)]="Selection_KarshnasMasol_Id" name="Selection_KarshnasMasol_Id">
          <option value="0">Select</option>
          <option *ngFor="let item of DataList_KarshnasMasol" [value]="item.id">
            <span *ngIf="item.sex==1">Mr.</span>
            <span *ngIf="item.sex==0">Ms.</span>
            {{item.fname}} {{item.lname}}
          </option>

        </select>
      </div>

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Address Customer</label>
        <select class="custom-select" [(ngModel)]="Selection_Address_Id" name="Selection_Address_Id">
          <option value="0">Select</option>
          <option *ngFor="let item of DataList_Address" [value]="item.id">{{item.title}}</option>
        </select>
      </div>

    </div>

    <div class="row" *ngIf="returenSelectedAddress()">

      <div class="form-group col-md-12">
        <input disabled value="{{returenSelectedAddress()}}" type="text" class="form-control">

      </div>


    </div>

    <br />
    <br />
    <br />

    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing && !can_submit" (click)="OnSubmit()" type="button" class="btn btn-success"
      style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>

      <button *ngIf="!InProccessing" (click)="Read_Customer_Info()" type="button" class="btn btn-info"
      style="margin-right: 5px;"><i class="fa fa-refresh"></i> Refresh</button>

  </form>



</div>